"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createStyle(doc, cssText) {
    var style = doc.createElement('style');
    style.type = 'text/css';
    style.appendChild(window.document.createTextNode(cssText));
    return style;
}
exports.createStyle = createStyle;
function createIFrame(parent) {
    if (parent === void 0) { parent = window.document.body; }
    var el = window.document.createElement('iframe');
    var css = 'visibility:hidden;width:0;height:0;position:absolute;z-index:-9999;bottom:0;';
    el.setAttribute('src', 'about:blank');
    el.setAttribute('style', css);
    el.setAttribute('width', '0');
    el.setAttribute('height', '0');
    el.setAttribute('wmode', 'opaque');
    parent.appendChild(el);
    return el;
}
exports.createIFrame = createIFrame;
var Printd = /** @class */ (function () {
    function Printd(parent) {
        if (parent === void 0) { parent = window.document.body; }
        this.parent = parent;
        this.iframe = createIFrame(this.parent);
    }
    Printd.prototype.getIFrame = function () {
        return this.iframe;
    };
    Printd.prototype.print = function (el, cssText, callback) {
        var _this = this;
        var _a = this.iframe, contentDocument = _a.contentDocument, contentWindow = _a.contentWindow;
        if (!contentDocument || !contentWindow)
            return;
        if (cssText) {
            contentDocument.head.appendChild(createStyle(contentDocument, cssText));
        }
        var elCopy = el.cloneNode(true);
        if (elCopy) {
            contentDocument.body.innerHTML = '';
            contentDocument.body.appendChild(elCopy);
            if (callback) {
                callback({
                    window: contentWindow,
                    document: contentDocument,
                    element: elCopy,
                    launchPrint: function () { return _this.launchPrint(contentWindow); }
                });
            }
            else {
                this.launchPrint(contentWindow);
            }
        }
    };
    Printd.prototype.launchPrint = function (contentWindow) {
        var result = contentWindow.document.execCommand('print', false, null);
        if (!result) {
            contentWindow.print();
        }
    };
    return Printd;
}());
exports.Printd = Printd;
exports.default = Printd;



//////////////////
// WEBPACK FOOTER
// ./node_modules/printd/index.js
// module id = 5OkI
// module chunks = 0